import { render, staticRenderFns } from "./myteamatt.vue?vue&type=template&id=6b2f476a&scoped=true&"
import script from "./myteamatt.vue?vue&type=script&lang=js&"
export * from "./myteamatt.vue?vue&type=script&lang=js&"
import style0 from "./myteamatt.vue?vue&type=style&index=0&id=6b2f476a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2f476a",
  null
  
)

export default component.exports